import { render, staticRenderFns } from "./provider-layout.vue?vue&type=template&id=b036867e&scoped=true"
import script from "./provider-layout.vue?vue&type=script&lang=js"
export * from "./provider-layout.vue?vue&type=script&lang=js"
import style0 from "./provider-layout.vue?vue&type=style&index=0&id=b036867e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b036867e",
  null
  
)

export default component.exports